import { GETREQUESTOPTIONS, instance } from '../apiService';

export interface NotificationAction {
    type: 'external_link';
    label: string;
    url: string;
}

export interface INotification {
    _id?: string;
    uid?: string;
    receiver_id?: string;
    creator_id?: string;
    title?: string;
    description?: string;
    video_id?: string;
    isImportant?: boolean;
    targetRights?: string[];
    targetPermissions?: string[];
    targetDepartmentIds?: string[];
    /** Optional action attached to this notification (e.g. an external link). */
    action?: NotificationAction;
    checked?: boolean;
    shownAt?: string | null;
    dismissedAt?: string | null;
    readAt?: string | null;
    createdAt?: string;
    updatedAt?: string;
    count?: number;
    totalCount?: number;
    shownCount?: number;
    dismissedCount?: number;
    readCount?: number;
}

export interface CreateNotificationPayload {
    title: string;
    description: string;
    video_id?: string;
    isImportant?: boolean;
    targetRights?: string[];
    targetPermissions?: string[];
    targetDepartmentIds?: string[];
    targetUserIds?: string[];
    action?: NotificationAction;
}

export const createNotification = async (
    payload: CreateNotificationPayload
) => {
    const res = await instance.post(
        '/api/notification/create',
        payload,
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const deleteNotification = async (id: string) => {
    const res = await instance.post(
        '/api/notification/delete',
        { id },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const deleteByUid = async (uid: string) => {
    const res = await instance.post(
        '/api/notification/delete-by-uid',
        { uid },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const markNotificationShown = async (id: string) => {
    const res = await instance.post(
        '/api/notification/shown',
        { id },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const dismissNotification = async (id: string) => {
    const res = await instance.post(
        '/api/notification/dismiss',
        { id },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const markNotificationAsRead = async (id: string) => {
    const res = await instance.post(
        '/api/notification/mark-read',
        { id },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const getNotifications = async () => {
    const res = await instance.get(
        '/api/notification/user',
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const getAllNotifications = async () => {
    const res = await instance.get(
        '/api/notification/all',
        GETREQUESTOPTIONS()
    );
    return res.data;
};
